// src/api/insuranceEtcApi.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit"
import { InsuranceEtcBaseSerializer, InsuranceGResponse, InsuranceGsResponse, InsuranceEtcSerializer } from "@/types/insurance"
import { CommonTResponse, CommonResponse } from "@/types/common"
import { serverApi, getAuthHeaders, handleApiResponse } from "@core/api/core"

// 서버에서 보험 지급보증서 목록 가져오는 비동기 thunk 생성
export const fetchInsuranceGs = createAsyncThunk<
  InsuranceEtcSerializer[],
  string, // insuranceUuid를 인자로 받음
  { rejectValue: string }
>("insurance/fetchInsuranceGs", async (insuranceUuid, { rejectWithValue }) => {
  try {
    const requestUrl = `/insurance/${insuranceUuid}/etc/`
    const response = await serverApi.get<CommonTResponse<InsuranceEtcSerializer>>(requestUrl)
    return handleApiResponse<InsuranceEtcSerializer[]>(response)
  } catch (error: any) {
    return rejectWithValue(error.message || "환자 정보 리스트 가져오기 실패")
  }
})

export const createInsuranceG = async (data: Partial<InsuranceEtcSerializer>): Promise<boolean> => {
  const requestUrl = `/insurance/${data.insuranceUuid}/etc/`
  const response = await serverApi.post<CommonResponse>(requestUrl, data)
  return handleApiResponse<boolean>(response)
}

export const updateInsuranceG = async (data: Partial<InsuranceEtcSerializer>): Promise<boolean> => {
  // console.log("updateInsuranceG data:", data)
  const payload: Record<string, unknown> = {
    insuranceTaInsno: data.insuranceTaInsno?.trim() || "",
    effectiveDate: data.effectiveDate,
    expirationDate: data.expirationDate,
  }

  const regno = data.insuranceTaRegno?.trim()
  if (regno) payload.insuranceTaRegno = regno
  if (data.insuranceTaCompany) payload.insuranceTaCompany = data.insuranceTaCompany
  if (data.insuranceOnsetDate) payload.insuranceOnsetDate = data.insuranceOnsetDate

  const requestUrl = `/insurance/${data.insuranceUuid}/etc/${data.insuranceEtcUuid}/`
  const response = await serverApi.patch<CommonResponse>(requestUrl, payload)

  return handleApiResponse<boolean>(response)
}

// 서버에서 특정 보험 지급보증서 가져오기
export const getInsuranceGs = async (insuranceUuid: string): Promise<InsuranceEtcSerializer[]> => {
  const requestUrl = `/insurance/${insuranceUuid}/etc/`
  console.log("getInsuranceGs insuranceUuid:", insuranceUuid)
  const response = await serverApi.get<CommonTResponse<InsuranceEtcSerializer>>(requestUrl)
  console.log("getInsuranceGs response:", response)
  return handleApiResponse<InsuranceEtcSerializer[]>(response)
}
